import React from 'react';
import bem from 'utils/bem';

import './index.sass';

const { cnBlock } = bem('button');

export const Button = ({className, Tag = 'button', to, mod = '', children, ...rest}) => {
    return <Tag className={ cnBlock(className, ...Array.isArray(mod) ? mod : [mod]) } to={to} {...rest}>
        {children}
    </Tag>;
}

export { LinkButton } from './LinkButton';
export { IconButton } from './IconButton';
